import httpService from "services/api.service";

export const getInventory = async (params) => {
  try {
    const res = await httpService.get("/inventory", { params });

    return res;
  } catch (error) {
    throw error.response.data.msg;
  }
};
